import * as React from "react";
const SvgFiRrPets = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pets_svg__a)">
      <path
        fill="#062147"
        d="M20.726 18.63c.283.485.39 1.061.3 1.622l-.197 1.225a2.99 2.99 0 0 1-2.962 2.524H13a1 1 0 0 1 0-2h4.867a.995.995 0 0 0 .987-.84l.197-1.225a.45.45 0 0 0-.054-.3c-1.015-1.745-1.069-2.172-1.095-2.377-.14-1.106-.662-1.792-1.747-2.295-.059-.027-1.905-.963-2.604-.963-.798 0-1.256.22-1.261.222-3.025 1.781-5.918 4.108-6.257 8.85a1 1 0 0 1-.997.928q-.036 0-.072-.002a1 1 0 0 1-.926-1.069c.409-5.71 4.11-8.589 7.29-10.458.061-.033.292-.152.673-.262v-.209c0-1.256.772-2.495 1.867-2.942.543-.222 1.133.221 1.133.807v2.405c.726.237 1.996.878 1.996.878 1.693.784 2.666 2.083 2.891 3.858 0 0 .106.364.838 1.622M21.5 6h-.227a2.78 2.78 0 0 1-2.14-1.002l-.229-.275a4.77 4.77 0 0 0-3.676-1.722h-1.227V.865c0-.586-.59-1.029-1.133-.807C11.773.505 11.001 1.744 11.001 3v.706l-2.57 3.998A4.98 4.98 0 0 1 4.225 10H1a1 1 0 0 0 0 2h3.224a6.97 6.97 0 0 0 5.889-3.215L12.546 5h2.681c.829 0 1.609.365 2.14 1.002l.229.275A4.77 4.77 0 0 0 21.272 8h.227a.5.5 0 0 1 .5.5V9a3.01 3.01 0 0 1-1.5 2.6 1 1 0 0 0 .502 1.865c.17 0 .342-.043.5-.134a5.02 5.02 0 0 0 2.5-4.33v-.5c0-1.379-1.122-2.5-2.5-2.5z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pets_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPets;
